// services/reportService.js

//const urlReportServer = JSON.parse(localStorage.getItem('urlReportServer') || '{}');  

const getReportServerUrl = () => {
  // En producción, usar el proxy de Nginx
  if (process.env.NODE_ENV === 'production') {
    return '/report';  // Nginx redirige a http://app.dapinformatica.com:8077/report
  }
  
  // En desarrollo, usar directo o proxy local
  return 'http://192.168.1.16:8077/report';
};

const urlReportServer = getReportServerUrl();

export const reportService2 = {
  /**
   * Genera un reporte en PDF
   * @param {Object} params - Parámetros del reporte
   * @param {string} params.hotelCode - Código del hotel
   * @param {string} params.reportName - Nombre del reporte
   * @param {string} params.sqlQuery - Consulta SQL para el reporte
   * @param {string} params.token - Token de autenticación (opcional)
   * @param {Function} params.onLoadingUpdate - Callback para actualizar estado de carga
   * @returns {Promise<Object>} - Retorna { success: boolean, pdfBase64: string }
   */
  async generateReport({ hotelCode, reportName, sqlQuery, token = null, onLoadingUpdate = null }) {
    // Validar parámetros requeridos
    if (!hotelCode || !reportName || !sqlQuery) {
      throw new Error('Faltan parámetros requeridos: hotelCode, reportName, sqlQuery');
    }

    // Actualizar estado de carga si se proporciona callback
    if (onLoadingUpdate) {
      onLoadingUpdate(true, `Generando ${reportName}...`);
    }

    try {
      // Obtener token si no se proporcionó
      const authToken = token || localStorage.getItem('token');
      
      if (!authToken) {
        throw new Error('No se encontró token de autenticación. Por favor, inicie sesión nuevamente.');
      }

      const url = `${urlReportServer}`;  // Si urlReportServer ya incluye /report, no agregar

      console.log('📡 Report URL:', url);
      console.log('📡 Environment:', process.env.NODE_ENV);

      // Log para debugging
      console.log(`Generando reporte "${reportName}" para hotel ${hotelCode} `,urlReportServer);

      // Realizar la petición
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        //   'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          hotelCode,
          reportName,
          sqlQuery
        }),
        mode: 'cors',
        credentials: 'omit'
      });

      console.log(" response => ",response);
      

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error en respuesta del servidor:', errorText);
        
        let errorMsg = `Error ${response.status}`;
        try {
          const errorData = JSON.parse(errorText);
          if (errorData.error) {
            errorMsg = errorData.error;
          }
        } catch (e) {
          if (errorText) {
            errorMsg = errorText;
          }
        }
        throw new Error(errorMsg);
      }

      // Procesar respuesta
      const responseText = await response.text();
      console.log('Respuesta recibida (primeros 200 chars):', responseText.substring(0, 200));
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('Error parseando JSON:', parseError);
        
        // Intentar limpiar el texto
        const cleanText = responseText
          .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
          .replace(/\r/g, '')
          .replace(/\n/g, '');
        
        try {
          data = JSON.parse(cleanText);
        } catch (e) {
          throw new Error('El servidor devolvió datos inválidos. Contacte con el administrador.');
        }
      }
      
      if (!data.success) {
        throw new Error(data.error || `Error al generar el reporte "${reportName}"`);
      }

      if (!data.pdfbase64) {
        throw new Error('No se recibió el PDF');
      }

      // Actualizar estado de carga completado
      if (onLoadingUpdate) {
        onLoadingUpdate(false, 'Reporte generado exitosamente');
      }

      return {
        success: true,
        pdfBase64: data.pdfbase64,
        data: data // Incluir datos adicionales si el servidor los envía
      };

    } catch (error) {
      // Actualizar estado de carga con error
      if (onLoadingUpdate) {
        onLoadingUpdate(false, 'Error al generar reporte', true);
      }
      
      throw error;
    }
  },

  /**
   * Muestra un PDF en una nueva ventana
   * @param {string} pdfBase64 - Base64 del PDF
   * @returns {string} - URL creada para el blob
   */
  displayPDF(pdfBase64) {
    try {
      // Limpiar el Base64
      const cleanBase64 = pdfBase64
        .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
        .replace(/\s/g, '');
      
      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      
      // Abrir en nueva ventana
      const newWindow = window.open(url, '_blank');
      
      // Limpiar URL después de 5 segundos
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 5000);

      return url;
    } catch (error) {
      console.error('Error mostrando PDF:', error);
      throw new Error('Error al mostrar el PDF: ' + error.message);
    }
  },

  /**
   * Genera y muestra un reporte en una sola llamada
   * @param {Object} params - Mismos parámetros que generateReport
   */
  async generateAndDisplayReport(params) {
    const result = await this.generateReport(params);
    if (result.success && result.pdfBase64) {
      this.displayPDF(result.pdfBase64);
    }
    return result;
  }
};

// Exportar también funciones individuales
export const generateReport = reportService2.generateReport.bind(reportService2);
export const displayPDF = reportService2.displayPDF.bind(reportService2);
export const generateAndDisplayReport = reportService2.generateAndDisplayReport.bind(reportService2);